<div class="boxWhite">
  <h4 class="clRed">CERRAR SESIÓN</h4>

  <button class="btn btnClose" (click)="close()">
    <img src="assets/img/icoClose.svg" alt="">
  </button>

  <div class="contModal">
    <p class="clGray">¿Esta Ud seguro que desea cerrar su sesión?</p>
  </div>

  <div class="footModal">
    <button class="btn btnRed w-100" (click)="cerrarSesion()">SI, CERRAR SESIÓN</button>
  </div>
</div>

